function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from './styles.module.scss';
import ErrorView from '@profile/src/Components/ErrorView';
import { ErrorViewType } from '@profile/src/Components/ErrorView/config';
import Button from '@profile/src/Components/Button';
import { openInNewTab } from '../../utils';
import Modal from '@profile/src/Components/PopupModal_V2';
import { CONTACT_SUPPORT_URL } from '@profile/src/constants';
import { useTestId } from '@wolffun/testable-id';

const ErrorModal = ({
  onClose
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  return /*#__PURE__*/React.createElement(Modal, _extends({}, generateTestIdProps('close-button'), {
    onClose: onClose
  }), /*#__PURE__*/React.createElement(ErrorView, {
    config: {
      type: ErrorViewType.Unknown
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, _extends({}, generateTestIdProps('i-got-it-button'), {
    onClick: onClose,
    className: styles.btn,
    title: "I got it"
  })), /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('contact-support'), {
    onClick: () => openInNewTab(CONTACT_SUPPORT_URL),
    className: styles.span
  }), "Contact support")));
};

export default ErrorModal;